import { api } from "../../../../../utility/api";
import { useDebouncedAsyncSelect } from "../../../Utils/Hooks/useDebounce";

// Opciones del select de producto padre, que comparten los reportes de
// producción y el cierre mensual
export const usePadresProductoTerminado = () =>
    useDebouncedAsyncSelect(function (search) {
        return api
            .get("padres_producto_terminado", { search })
            .then((data) => {
                if (data) return data.results;
                return [];
            })
            .catch(() => {
                return [];
            });
    });
